import { classes } from 'html-classes';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import { usePromocode } from '~/hooks/usePromocode';

import { cartStore } from '~/stores';

import Icon from '../Icon/Icon';

import styles from './Promocode2.module.scss';

interface PromocodeVariant1Props {
  disabled?: boolean | null;
}

const Promocode2 = ({ disabled }: PromocodeVariant1Props) => {
  const { t } = useTranslation();

  const {
    promocodeVal,
    warningMsg,
    isLoading,
    handlePromocodeChange,
    handleDelPromocode,
    handleSubmit,
  } = usePromocode();

  return (
    <form
      className={classes(['promocode__form', styles.root])}
      onSubmit={handleSubmit}
    >
      <div
        className={classes([
          'promocode__form-control',
          styles.promocode__formControl,
          promocodeVal.length &&
            cartStore.promocode.success === null &&
            styles._filled,
          cartStore.promocode.errorType === 'error' && styles._error,
          (cartStore.promocode.errorType === 'warning' || warningMsg) &&
            styles._warning,
          cartStore.promocode.success === true &&
            !warningMsg &&
            styles._success,
        ])}
      >
        <div
          className={classes([
            'checkout-summary__promocode-content',
            styles.checkoutSummary__promocodeContent,
            styles.promocodeContent,
          ])}
        >
          <input
            className={classes([isLoading && '_loading', styles.input])}
            placeholder={t('promocode')}
            value={promocodeVal}
            onChange={handlePromocodeChange}
            disabled={isLoading || Boolean(disabled)}
          />
          {cartStore.promocode.success !== null &&
          promocodeVal === cartStore.promocode.value ? (
            <button
              className={classes(['button', styles.button, styles.remove])}
              type="submit"
              onClick={handleDelPromocode}
              disabled={Boolean(disabled)}
            >
              <Icon type="trash" size={24} className={styles.icon} />
            </button>
          ) : (
            promocodeVal && (
              <button
                className={classes([
                  'button',
                  '_primary',
                  styles.button,
                  styles.accept,
                ])}
                type="submit"
                disabled={isLoading || Boolean(disabled)}
              >
                {isLoading ? (
                  <span className={classes(['spinner _white'])} />
                ) : (
                  t('apply')
                )}
              </button>
            )
          )}
        </div>
        {!isLoading && cartStore.promocode.message && (
          <p
            className={classes([
              'promocode__form-control-result',
              styles.promocode__formControlResult,
            ])}
          >
            {cartStore.promocode.message}
          </p>
        )}
      </div>
      {warningMsg && !isLoading && (
        <div className={classes(['alert _warning mt-16 z-1', styles.alert])}>
          {warningMsg}
        </div>
      )}
    </form>
  );
};

export default observer(Promocode2);
